import { ISetVehicleAnnotations } from "../interfaces/garage.interface";

function setVehicleAnnotations(data: any): ISetVehicleAnnotations {
  return {
    type: "SET_VEHICLE_ANNOTATIONS",
    data,
  };
}
export default setVehicleAnnotations;
